export default __webpack_public_path__ + "static/media/drawer.1f82680a.png";